module.exports = __webpack_public_path__ + "ws.svg?2690f3d8a35c6ca0343fe931be856dc4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ws.svg
// module id = 1697
// module chunks = 0